/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Actions/ServiceEndpointActionsHub" />
import { IServiceEndpointDetails } from "DistributedTaskUI/ServiceEndpoints/Details/Source/ServiceEndpointsSource";
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";


export class ServiceEndpointActionsHub extends ActionsHubBase {
    public static getKey(): string {
        return "service-endpoints-actions";
    }

    public initialize(instanceId?: string): void {
        this._initializeServiceEndpointHubData = new Action<IServiceEndpointDetails>();
        this._setServiceEndpointOwnerEmail = new Action<string>();
        this._setServiceEndpointNotFoundFlag = new Action<boolean>();
        this._setMonitorSchemeConversionProgress = new Action<boolean>();
        this._setEditingEnabled = new Action<boolean>();
        this._updateServiceEndpointAuthenticationScheme = new Action<string>();
        this._serviceEndpoint = new Action<ServiceEndpoint>();
    }

    public get initializeServiceEndpointHubData(): Action<IServiceEndpointDetails> {
        return this._initializeServiceEndpointHubData;
    }

    public get setServiceEndpointOwnerEmail(): Action<string> {
        return this._setServiceEndpointOwnerEmail;
    }

    public get setServiceEndpointNotFoundFlag(): Action<boolean> {
        return this._setServiceEndpointNotFoundFlag;
    }

    public get updateServiceEndpointSharedFlag(): Action<ServiceEndpoint> {
        return this._serviceEndpoint;
    }

    public get updateServiceEndpointAuthenticationScheme(): Action<string> {
        return this._updateServiceEndpointAuthenticationScheme;
    }

    public get setMonitorSchemeConversionProgress(): Action<boolean> {
        return this._setMonitorSchemeConversionProgress;
    }

    public get setEditingEnabled(): Action<boolean> {
        return this._setEditingEnabled;
    }

    private _setServiceEndpointOwnerEmail: Action<string>;
    private _setServiceEndpointNotFoundFlag: Action<boolean>;
    private _initializeServiceEndpointHubData: Action<IServiceEndpointDetails>;
    private _updateServiceEndpointAuthenticationScheme: Action<string>;
    private _setMonitorSchemeConversionProgress: Action<boolean>;
    private _serviceEndpoint: Action<ServiceEndpoint>;
    private _setEditingEnabled: Action<boolean>;
}
